'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WAMConstants = require('../constants/WAMConstants');

var _WAMErrors = require('../errors/WAMErrors');

var _CommonUtil = require('../util/CommonUtil');

var _CommonUtil2 = _interopRequireDefault(_CommonUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GlobalData = function () {
	function GlobalData() {
		_classCallCheck(this, GlobalData);

		if (this.instance) {
			return this.instance;
		}
		this.instance = this;
		this.appId = null;
		this.appType = null;
		this.clientId = null;
		this.accessToken = null;
		this.userContext = {};
		this.callbacks = {};
		this.thorConnection = {};
		this.isInitialized = false;
		this.ccdDetectPromise = null;
	}

	_createClass(GlobalData, [{
		key: 'addCallbacks',
		value: function addCallbacks(initConfigJson) {
			if (initConfigJson.callbacks.onCCDDetectionCallbacks) {
				this.callbacks.onCCDDetectionCallbacks = this.callbacks.onCCDDetectionCallbacks || [];
				this.callbacks.onCCDDetectionCallbacks.push(initConfigJson.callbacks.onCCDDetectionCallback);
			}
			if (initConfigJson.callbacks.onSuccessCallback) {
				this.callbacks.onSuccessCallbacks = this.callbacks.onSuccessCallbacks || [];
				this.callbacks.onSuccessCallbacks.push(initConfigJson.callbacks.onSuccessCallback);
			}
			if (initConfigJson.callbacks.onFailureCallback) {
				this.callbacks.onFailureCallbacks = this.callbacks.onFailureCallbacks || [];
				this.callbacks.onFailureCallbacks.push(initConfigJson.callbacks.onFailureCallback);
			}
			if (initConfigJson.callbacks.onMessageCallback) {
				this.callbacks.onMessageCallbacks = this.callbacks.onMessageCallbacks || [];
				this.callbacks.onMessageCallbacks.push(initConfigJson.callbacks.onMessageCallback);
			}
			if (initConfigJson.callbacks.onCloseConfirmationCallback) {
				this.callbacks.onCloseConfirmationCallbacks = this.callbacks.onCloseConfirmationCallbacks || [];
				this.callbacks.onCloseConfirmationCallbacks.push(initConfigJson.callbacks.onCloseConfirmationCallback);
			}
			if (initConfigJson.callbacks.analyticsCallback) {
				this.callbacks.analyticsCallbacks = this.callbacks.analyticsCallbacks || [];
				this.callbacks.analyticsCallbacks.push(initConfigJson.callbacks.analyticsCallback);
			}
			if (initConfigJson.callbacks.clientTokenExpiryCheck) {
				if (!this.callbacks.clientTokenExpiryCheck) {
					this.callbacks.clientTokenExpiryCheck = initConfigJson.callbacks.clientTokenExpiryCheck;
				}
			}
		}
	}, {
		key: 'initializeContext',
		value: function initializeContext(initConfigJson) {
			if (this.isInitialized) {
				return { status: true };
			}
			if (!initConfigJson) {
				return { status: false, error: _WAMErrors.initialize.errors.initContextUndefined };
			}
			if (!initConfigJson.env) {
				return { status: false, error: _WAMErrors.initialize.errors.envUndefined };
			}
			if (!initConfigJson.clientId) {
				return { status: false, error: _WAMErrors.initialize.errors.clientIdUndefined };
			}

			if (!initConfigJson.callbacks) {
				return { status: false, error: _WAMErrors.initialize.errors.callbacksUndefined };
			}
			if (!initConfigJson.callbacks.onSuccessCallback) {
				return { status: false, error: _WAMErrors.initialize.errors.onSuccessCallbackUndefined };
			}
			if (!initConfigJson.callbacks.onFailureCallback) {
				return { status: false, error: _WAMErrors.initialize.errors.onFailureCallbackUndefined };
			}
			if (!initConfigJson.callbacks.onMessageCallback) {
				return { status: false, error: _WAMErrors.initialize.errors.onMessageCallbackUndefined };
			}
			if (!_WAMConstants.wamUrls[initConfigJson.env]) {
				return { status: false, error: _WAMErrors.initialize.errors.environmentInvalid };
			}
			this.appId = initConfigJson.appId;
			this.appType = initConfigJson.appType;
			this.env = initConfigJson.env;
			this.clientId = initConfigJson.clientId;
			this.analyticsParams = initConfigJson.analyticsParams;

			this.isLoggingEnabled = initConfigJson.isLoggingEnabled;
			if (typeof initConfigJson.shouldTryHttpPing === 'undefined' || initConfigJson.shouldTryHttpPing === null) {
				this.shouldTryHttpPing = true;
			} else {
				this.shouldTryHttpPing = initConfigJson.shouldTryHttpPing;
			}
			if (typeof initConfigJson.disconnectOnUserMismatch === 'undefined' || initConfigJson.disconnectOnUserMismatch === null) {
				this.disconnectOnUserMismatch = true;
			} else {
				this.disconnectOnUserMismatch = initConfigJson.disconnectOnUserMismatch;
			}
			this.thorConnection.error = null;
			this.addCallbacks(initConfigJson);
			this.isInitialized = true;
			return { status: true };
		}
	}, {
		key: 'initializeUserContext',
		value: function initializeUserContext(userContext) {
			if (!(userContext && userContext.accessToken)) {
				return { status: false, error: _WAMErrors.initialize.errors.accessTokenUndefined };
			}
			this.accessToken = userContext.accessToken;
			var imsTokenPayload = _CommonUtil2.default.extractPayloadFromToken(userContext.accessToken);
			if (imsTokenPayload) {
				this.userContext.userId = imsTokenPayload.user_id;
			}
			if (!this.userContext.userId) {
				return { status: false, error: _WAMErrors.initialize.errors.accessTokenInvalid };
			}
			this.userContext.email = userContext.email;
			this.userContext.displayName = userContext.displayName;
			return { status: true };
		}
	}]);

	return GlobalData;
}();

exports.default = new GlobalData();